export const siteConfig = {
  brandName: "jailorchard",
  legalName: "All for One Culture Communication Co., Limited",
  logo: "jailorchard",
  description:
    "Independent design studio connecting people through fashion, culture and considered craft.",
  currency: "EUR",
  currencySymbol: "€",
  locale: "en-IE",
  freeShippingThreshold: 150,
  shippingFlatRate: 7.5,
  contact: {
    email: "drive@jailorchard.xyz",
    phone: "",
    address: "RM D5, 5/F KING YIP FTY BLDGNO.59 KING YIP STREETKWUN TONGKL",
    hours: "Monday–Friday, 09:00–17:30 CET",
  },
  announcements: [
    "Complimentary shipping from €150",
    "Earn loyalty points with every purchase",
    "30-day returns and exchanges",
  ],
};

const shoeSizes = [
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
];
const clothingSizes = ["XS", "S", "M", "L", "XL", "XXL"];

const productData = [
  {
    id: 1,
    name: "Squareline Loafer Black Stripe",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 300,
    compareAtPrice: null,
    image: "/img/products/01-squareline-loafer-black-stripe.jpg",
    images: ["/img/products/01-squareline-loafer-black-stripe.jpg"],
    size: shoeSizes,
    colors: ["Black Stripe"],
    material: "Premium calf leather",
    description: [
      "A limited square-toe loafer balancing precise leatherwork with a bolder graphic rhythm.",
      "The padded lining and grounded outsole are designed for confident, all-day wear.",
    ],
    features: [
      "Square-toe silhouette",
      "Full leather lining",
      "Durable rubber outsole",
      "Hand-finished construction",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "We recommend sizing down",
      color: "Black Stripe",
    },
    tags: ["Exclusive", "Loafer", "Unisex"],
    status: "EXCLUSIVE",
    stock: 4,
    rating: 4.8,
    reviews: 18,
  },
  {
    id: 2,
    name: "Studio Relaxed T-Shirt Celestial Blue",
    category: "T-Shirts",
    productType: "Clothing",
    gender: "Unisex",
    price: 75,
    compareAtPrice: null,
    image: "/img/products/02-studio-relaxed-tshirt-blue.jpg",
    images: ["/img/products/02-studio-relaxed-tshirt-blue.jpg"],
    size: clothingSizes,
    colors: ["Celestial Blue"],
    material: "Heavyweight organic cotton jersey",
    description: [
      "A relaxed everyday T-shirt cut with dropped shoulders and a clean, weighty drape.",
      "Garment washing softens the celestial-blue cotton while preserving its structured shape.",
    ],
    features: [
      "240 gsm jersey",
      "Dropped shoulder",
      "Ribbed crew neck",
      "Garment washed",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Relaxed fit",
      color: "Celestial Blue",
    },
    tags: ["New", "T-Shirt", "Organic Cotton"],
    status: "NEW",
    stock: 18,
    rating: 4.7,
    reviews: 12,
  },
  {
    id: 3,
    name: "Minimal Cupsole All White",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 200,
    image: "/img/products/03-minimal-cupsole-white.jpg",
    images: ["/img/products/03-minimal-cupsole-white.jpg"],
    size: shoeSizes,
    colors: ["All White"],
    material: "Smooth leather and rubber",
    description: [
      "A stripped-back court sneaker made in tonal white leather with softly sculpted proportions.",
      "The cushioned footbed and flexible cupsole make it an easy foundation for daily dressing.",
    ],
    features: [
      "Leather upper",
      "Perforated forefoot",
      "Cushioned footbed",
      "Stitched cupsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "All White",
    },
    tags: ["Sale", "Sneaker", "Bestseller"],
    status: "SALE",
    stock: 11,
    rating: 4.8,
    reviews: 146,
  },
  {
    id: 4,
    name: "Gradient Penny Loafer Black",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 250,
    compareAtPrice: 350,
    image: "/img/products/04-gradient-penny-loafer-black.jpg",
    images: ["/img/products/04-gradient-penny-loafer-black.jpg"],
    size: shoeSizes,
    colors: ["Degrade Black"],
    material: "Gradient-finished calf leather",
    description: [
      "A substantial penny loafer shaped with a rounded profile and hand-worked tonal finish.",
      "Its cushioned lining and lightweight lug sole soften the strong, architectural volume.",
    ],
    features: [
      "Gradient leather finish",
      "Hand-stitched apron",
      "Padded leather lining",
      "Lightweight lug sole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "Degrade Black",
    },
    tags: ["Sale", "Loafer", "Statement"],
    status: "SALE",
    stock: 7,
    rating: 4.7,
    reviews: 39,
  },
  {
    id: 5,
    name: "Lowline Suede Sneaker Organic Beige",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 210,
    image: "/img/products/05-lowline-suede-beige.jpg",
    images: ["/img/products/05-lowline-suede-beige.jpg"],
    size: shoeSizes,
    colors: ["Organic Beige"],
    material: "Premium suede and natural rubber",
    description: [
      "A calm, low-profile sneaker combining softly curved suede panels with a warm tonal palette.",
      "Breathable lining and a cushioned footbed keep the everyday silhouette comfortable.",
    ],
    features: [
      "Suede upper",
      "Breathable lining",
      "Cushioned footbed",
      "Natural rubber outsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "Organic Beige",
    },
    tags: ["Sale", "Lowline", "Lightweight"],
    status: "SALE",
    stock: 9,
    rating: 4.6,
    reviews: 84,
  },
  {
    id: 6,
    name: "Retro Suede Runner Beige",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 130,
    compareAtPrice: 230,
    image: "/img/products/06-retro-suede-runner-beige.jpg",
    images: ["/img/products/06-retro-suede-runner-beige.jpg"],
    size: shoeSizes,
    colors: ["Beige"],
    material: "Short-nap suede and gum rubber",
    description: [
      "A slim retro-inspired sneaker refined through layered beige suede and a low gum sole.",
      "The flexible build is made for long city days without losing its crisp profile.",
    ],
    features: [
      "Suede construction",
      "Cotton laces",
      "Leather sockliner",
      "Flexible gum outsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "Beige",
    },
    tags: ["Sale", "Retro", "Sneaker"],
    status: "SALE",
    stock: 8,
    rating: 4.7,
    reviews: 63,
  },
  {
    id: 7,
    name: "Folded Vamp Loafer Black",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 390,
    compareAtPrice: null,
    image: "/img/products/07-folded-vamp-loafer-black.jpg",
    images: ["/img/products/07-folded-vamp-loafer-black.jpg"],
    size: shoeSizes,
    colors: ["Black"],
    material: "Soft polished calf leather",
    description: [
      "An expressive slip-on loafer formed around an organic folded vamp and clean heel line.",
      "Hand-burnished leather gives each pair subtle variation and a character that deepens over time.",
    ],
    features: [
      "Sculpted folded vamp",
      "Leather lining",
      "Hand-burnished finish",
      "Stacked leather heel",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "We recommend sizing down",
      color: "Black",
    },
    tags: ["Popular", "Loafer", "Premium"],
    status: "POPULAR",
    stock: 5,
    rating: 4.9,
    reviews: 31,
  },
  {
    id: 8,
    name: "Square Nubuck Loafer Charcoal",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 320,
    compareAtPrice: null,
    image: "/img/products/08-square-nubuck-loafer-charcoal.jpg",
    images: ["/img/products/08-square-nubuck-loafer-charcoal.jpg"],
    size: shoeSizes,
    colors: ["Hazy Black"],
    material: "Matte nubuck leather",
    description: [
      "A pared-back loafer with a velvety charcoal surface and an elongated square toe.",
      "The understated construction is finished with a soft leather lining and thin architectural sole.",
    ],
    features: [
      "Nubuck upper",
      "Squared toe",
      "Full leather lining",
      "Slim rubber sole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "Hazy Black",
    },
    tags: ["New", "Loafer", "Minimal"],
    status: "NEW",
    stock: 6,
    rating: 4.7,
    reviews: 9,
  },
  {
    id: 9,
    name: "Woven Apron Loafer Black",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 270,
    compareAtPrice: 390,
    image: "/img/products/09-woven-apron-loafer-black.jpg",
    images: ["/img/products/09-woven-apron-loafer-black.jpg"],
    size: shoeSizes,
    colors: ["Black"],
    material: "Polished leather with woven apron",
    description: [
      "A directional loafer combining a familiar penny strap with hand-woven apron detailing.",
      "A sculpted block heel adds height while the padded interior supports daily wear.",
    ],
    features: [
      "Woven leather apron",
      "Padded sockliner",
      "Sculpted heel",
      "Leather-lined interior",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "Black",
    },
    tags: ["Sale", "Loafer", "Craft"],
    status: "SALE",
    stock: 3,
    rating: 4.8,
    reviews: 22,
  },
  {
    id: 10,
    name: "T-Shirt Slim White",
    category: "T-Shirts",
    productType: "Clothing",
    gender: "Unisex",
    price: 35,
    compareAtPrice: 55,
    image: "/img/products/10-tshirt-slim-white.jpg",
    images: ["/img/products/10-tshirt-slim-white.jpg"],
    size: clothingSizes,
    colors: ["White"],
    material: "Organic cotton jersey",
    description: [
      "A close-cut white T-shirt built as a clean base layer with a neat crew neck.",
      "Soft compact jersey holds its shape through repeated wear and washing.",
    ],
    features: [
      "Slim silhouette",
      "Organic cotton",
      "Bound neckline",
      "Twin-needle hem",
    ],
    attributes: { origin: "Made in Portugal", fit: "Slim fit", color: "White" },
    tags: ["Sale", "T-Shirt", "Essential"],
    status: "SALE",
    stock: 22,
    rating: 4.6,
    reviews: 71,
  },
  {
    id: 11,
    name: "T-Shirt Slim Black",
    category: "T-Shirts",
    productType: "Clothing",
    gender: "Unisex",
    price: 35,
    compareAtPrice: 55,
    image: "/img/products/11-tshirt-slim-black.jpg",
    images: ["/img/products/11-tshirt-slim-black.jpg"],
    size: clothingSizes,
    colors: ["Black"],
    material: "Organic cotton jersey",
    description: [
      "A refined black T-shirt shaped with a narrow neck and a clean, slim body.",
      "The dense organic jersey feels smooth against the skin and keeps a crisp silhouette.",
    ],
    features: [
      "Slim silhouette",
      "Organic cotton",
      "Ribbed neckline",
      "Pre-washed finish",
    ],
    attributes: { origin: "Made in Portugal", fit: "Slim fit", color: "Black" },
    tags: ["Sale", "T-Shirt", "Essential"],
    status: "SALE",
    stock: 19,
    rating: 4.7,
    reviews: 64,
  },
  {
    id: 12,
    name: "Tonal Suede Runner Off White",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 130,
    compareAtPrice: 240,
    image: "/img/products/12-tonal-suede-runner-off-white.jpg",
    images: ["/img/products/12-tonal-suede-runner-off-white.jpg"],
    size: shoeSizes,
    colors: ["Off White"],
    material: "Premium suede and translucent rubber",
    description: [
      "A tonal off-white sneaker with quiet panel transitions and a softly translucent outsole.",
      "The low stance and cushioned leather footbed create an easy, polished daily option.",
    ],
    features: [
      "Tonal suede upper",
      "Leather footbed",
      "Waxed cotton laces",
      "Translucent outsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "Off White",
    },
    tags: ["Sale", "Tonal", "Sneaker"],
    status: "€100 OFF",
    stock: 10,
    rating: 4.8,
    reviews: 53,
  },
  {
    id: 13,
    name: "Fine Knit Polo Antique White",
    category: "Knitwear",
    productType: "Clothing",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 180,
    image: "/img/products/13-fine-knit-polo-antique.jpg",
    images: ["/img/products/13-fine-knit-polo-antique.jpg"],
    size: clothingSizes,
    colors: ["Antique White"],
    material: "Fine-gauge cotton blend",
    description: [
      "A lightweight polo in antique white, designed with a relaxed body and subtle lustre.",
      "Fine ribbed edges give the easy summer layer a precise, dressed finish.",
    ],
    features: [
      "Fine-gauge knit",
      "Short sleeves",
      "Tonal buttons",
      "Ribbed trims",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Relaxed fit",
      color: "Antique White",
    },
    tags: ["Sale", "Knitwear", "Summer"],
    status: "SALE",
    stock: 12,
    rating: 4.6,
    reviews: 27,
  },
  {
    id: 14,
    name: "Fine Knit Polo Skyway",
    category: "Knitwear",
    productType: "Clothing",
    gender: "Unisex",
    price: 100,
    compareAtPrice: 180,
    image: "/img/products/14-fine-knit-polo-skyway.jpg",
    images: ["/img/products/14-fine-knit-polo-skyway.jpg"],
    size: clothingSizes,
    colors: ["Skyway"],
    material: "Fine cotton-viscose knit",
    description: [
      "An airy sky-blue polo with an open collar and restrained vertical texture.",
      "The breathable knit is designed to drape loosely without losing definition.",
    ],
    features: [
      "Open collar",
      "Vertical knit texture",
      "Breathable yarn",
      "Ribbed hem",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Relaxed fit",
      color: "Skyway",
    },
    tags: ["Sale", "Knitwear", "Summer"],
    status: "SALE",
    stock: 9,
    rating: 4.7,
    reviews: 21,
  },
  {
    id: 15,
    name: "Fine Knit Polo All Black",
    category: "Knitwear",
    productType: "Clothing",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 180,
    image: "/img/products/15-fine-knit-polo-black.jpg",
    images: ["/img/products/15-fine-knit-polo-black.jpg"],
    size: clothingSizes,
    colors: ["All Black"],
    material: "Textured cotton knit",
    description: [
      "A monochrome knit polo defined by an open collar and quiet geometric texture.",
      "Compact cotton yarn gives the relaxed shape enough structure for smarter styling.",
    ],
    features: [
      "Geometric rib texture",
      "Open neck",
      "Compact knit",
      "Tonal finishing",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Relaxed fit",
      color: "All Black",
    },
    tags: ["Sale", "Knitwear", "Monochrome"],
    status: "SALE",
    stock: 14,
    rating: 4.8,
    reviews: 18,
  },
  {
    id: 16,
    name: "Soft Cupsole Suede Off White",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 100,
    compareAtPrice: 200,
    image: "/img/products/16-soft-cupsole-suede-off-white.jpg",
    images: ["/img/products/16-soft-cupsole-suede-off-white.jpg"],
    size: shoeSizes,
    colors: ["Off White"],
    material: "Soft suede and rubber",
    description: [
      "A clean off-white court silhouette with tonal suede and a quietly curved eyestay.",
      "A padded collar and stitched cupsole balance polish with day-long comfort.",
    ],
    features: [
      "Suede upper",
      "Padded collar",
      "Leather sockliner",
      "Stitched cupsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "Off White",
    },
    tags: ["Sale", "Cupsole", "Sneaker"],
    status: "SALE",
    stock: 13,
    rating: 4.7,
    reviews: 98,
  },
  {
    id: 17,
    name: "Layered Cupsole Suede Light Grey",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 100,
    compareAtPrice: 200,
    image: "/img/products/17-layered-cupsole-suede-grey.jpg",
    images: ["/img/products/17-layered-cupsole-suede-grey.jpg"],
    size: shoeSizes,
    colors: ["Light Grey"],
    material: "Premium light-grey suede",
    description: [
      "A tonal court sneaker in cool light-grey suede with a subtly squared sole edge.",
      "Layered heel construction adds depth while the lightweight cupsole stays flexible.",
    ],
    features: [
      "Tonal suede upper",
      "Layered heel panel",
      "Cushioned footbed",
      "Rubber cupsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "Light Grey",
    },
    tags: ["Sale", "Cupsole", "Minimal"],
    status: "SALE",
    stock: 15,
    rating: 4.7,
    reviews: 74,
  },
  {
    id: 18,
    name: "Contrast Cupsole Suede Navy",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 200,
    image: "/img/products/18-contrast-cupsole-suede-navy.jpg",
    images: ["/img/products/18-contrast-cupsole-suede-navy.jpg"],
    size: shoeSizes,
    colors: ["Navy"],
    material: "Deep navy suede and ivory rubber",
    description: [
      "A deep navy court shoe set against a crisp ivory cupsole for a measured contrast.",
      "The smooth inner lining and flexible forefoot make the low profile comfortable from first wear.",
    ],
    features: [
      "Navy suede upper",
      "Tonal laces",
      "Leather lining",
      "Ivory rubber sole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "Navy",
    },
    tags: ["Sale", "Cupsole", "Sneaker"],
    status: "SALE",
    stock: 8,
    rating: 4.8,
    reviews: 81,
  },
  {
    id: 19,
    name: "Mono Cupsole Suede Black",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 200,
    image: "/img/products/19-mono-cupsole-suede-black.jpg",
    images: ["/img/products/19-mono-cupsole-suede-black.jpg"],
    size: shoeSizes,
    colors: ["Black"],
    material: "Black suede and matte rubber",
    description: [
      "An all-black court sneaker using texture and layered seams to define its monochrome form.",
      "The padded leather sockliner brings softness to the streamlined matte construction.",
    ],
    features: [
      "Black suede upper",
      "Curved toe panel",
      "Padded sockliner",
      "Matte cupsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "True to size",
      color: "Black",
    },
    tags: ["Sale", "Cupsole", "Monochrome"],
    status: "SALE",
    stock: 16,
    rating: 4.8,
    reviews: 92,
  },
  {
    id: 20,
    name: "Flow Athletic Suede White",
    category: "Sneakers",
    productType: "Shoes",
    gender: "Unisex",
    price: 150,
    compareAtPrice: 220,
    image: "/img/products/20-flow-athletic-suede-white.jpg",
    images: ["/img/products/20-flow-athletic-suede-white.jpg"],
    size: shoeSizes,
    colors: ["White"],
    material: "Suede, mesh and layered rubber",
    description: [
      "A broader athletic sneaker combining white suede, breathable mesh and flowing panel lines.",
      "The layered sole adds soft rebound without overpowering the tonal upper.",
    ],
    features: [
      "Mixed suede and mesh",
      "Layered foam footbed",
      "Padded tongue",
      "Grippy rubber outsole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "Regular fit",
      color: "White",
    },
    tags: ["Sale", "Athletic", "Sneaker"],
    status: "SALE",
    stock: 7,
    rating: 4.6,
    reviews: 47,
  },
  {
    id: 21,
    name: "Denim Jacket Tea",
    category: "Denim",
    productType: "Clothing",
    gender: "Unisex",
    price: 200,
    compareAtPrice: 300,
    image: "/img/products/21-denim-jacket-tea.jpg",
    images: ["/img/products/21-denim-jacket-tea.jpg"],
    size: clothingSizes,
    colors: ["Tea"],
    material: "Washed cotton denim",
    description: [
      "A cropped workwear jacket in a warm tea wash, cut with relaxed sleeves and clean square pockets.",
      "The substantial denim softens with wear while tonal seams keep the finish restrained.",
    ],
    features: [
      "Cropped shape",
      "Two chest pockets",
      "Matte hardware",
      "Garment washed",
    ],
    attributes: { origin: "Made in Portugal", fit: "Boxy fit", color: "Tea" },
    tags: ["Sale", "Denim", "Jacket"],
    status: "SALE",
    stock: 6,
    rating: 4.8,
    reviews: 24,
  },
  {
    id: 22,
    name: "Denim Pants Tea",
    category: "Denim",
    productType: "Clothing",
    gender: "Unisex",
    price: 120,
    compareAtPrice: 200,
    image: "/img/products/22-denim-pants-tea.jpg",
    images: ["/img/products/22-denim-pants-tea.jpg"],
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Tea"],
    material: "Washed cotton denim",
    description: [
      "Straight-leg jeans in a warm tea wash with a relaxed rise and softly pooling hem.",
      "A classic five-pocket construction is simplified through tonal topstitching and hardware.",
    ],
    features: [
      "Relaxed straight leg",
      "Five-pocket build",
      "Tonal stitching",
      "Garment washed",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Relaxed fit",
      color: "Tea",
    },
    tags: ["Sale", "Denim", "Pants"],
    status: "SALE",
    stock: 11,
    rating: 4.7,
    reviews: 19,
  },
  {
    id: 23,
    name: "T-Shirt Citrus Black",
    category: "T-Shirts",
    productType: "Clothing",
    gender: "Unisex",
    price: 50,
    compareAtPrice: 85,
    image: "/img/products/23-tshirt-citrus-black.jpg",
    images: ["/img/products/23-tshirt-citrus-black.jpg"],
    size: clothingSizes,
    colors: ["Black"],
    material: "Heavyweight organic cotton",
    description: [
      "A boxy black T-shirt marked only by a small citrus-toned stitch detail near the hem.",
      "Dense cotton jersey gives the wide body a controlled, architectural drape.",
    ],
    features: [
      "Boxy silhouette",
      "Organic cotton",
      "Small stitched detail",
      "Garment washed",
    ],
    attributes: {
      origin: "Made in Portugal",
      fit: "Oversized fit",
      color: "Black",
    },
    tags: ["Sale", "T-Shirt", "Graphic Detail"],
    status: "SALE",
    stock: 17,
    rating: 4.6,
    reviews: 16,
  },
  {
    id: 24,
    name: "Repair Stitch Loafer Black",
    category: "Loafers",
    productType: "Shoes",
    gender: "Unisex",
    price: 290,
    compareAtPrice: 390,
    image: "/img/products/24-repair-stitch-loafer-black.jpg",
    images: ["/img/products/24-repair-stitch-loafer-black.jpg"],
    size: shoeSizes,
    colors: ["Black"],
    material: "Polished calf leather",
    description: [
      "A polished black loafer traced with irregular ivory stitch lines inspired by repaired objects.",
      "The familiar penny shape is grounded by a durable outsole and a fully cushioned leather interior.",
    ],
    features: [
      "Ivory stitch artwork",
      "Polished leather",
      "Cushioned lining",
      "Durable rubber sole",
    ],
    attributes: {
      origin: "Handcrafted in Portugal",
      fit: "We recommend sizing down",
      color: "Black",
    },
    tags: ["Sale", "Restock", "Loafer"],
    status: "RESTOCK COMING SOON",
    stock: 0,
    rating: 4.9,
    reviews: 13,
  },
];

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 0,
  }).format(value);

export default productData;
